LookupCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    '$timeout',
    'configs',
    '$state',
    'Notification',
    '$translate',
    'PortalApi',
    'Localization'
];
function LookupCtrl($scope, $rootScope, $stateParams, $timeout, configs, $state, Notification, $translate, PortalApi, Localization) {
    $scope.activeSubmit = true;
    $scope.inputNumber = null;
    $scope.preLoader = false;
    $scope.payment = {
        paymentId: $stateParams.paymentId,
        serviceId: $stateParams.serviceId,
        furl: $stateParams.furl,
        name: $stateParams.name,
        category: $stateParams.category
    };
    $scope.smsCode = '';

    $scope.changeInput = function (data) {
        $scope.inputNumber = data;
        if ($scope.inputNumber != null) {
            $scope.activeSubmit = false;
        } else {
            $scope.activeSubmit = true;
        }
    };

    $scope.sendLookup = function () {
        $scope.preLoader = true;
        $scope.activeSubmit = true;

        PortalApi.verifyLookup($scope.payment.paymentId, $scope.smsCode)
            .then(function(res) {

                if (res.status === 'ok') {
                    return $scope.checkTrnStatus($scope.payment.paymentId);
                } else {
                    throw new Error('UNKNOWN_ERROR');
                }

            }).catch(function () {
                $scope.preLoader = false;
                $scope.activeSubmit = false;

                Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
            });
    };

    $scope.checkTrnStatus = function (paymentId) {
        PortalApi.check3Dsecure(paymentId).then(function(res) {
            var errorText = res && (res.error_text || (res.data && res.data.error_text));
            if (errorText) {
                $scope.preLoader = false;
                Notification.error({
                    message: errorText,
                    delay: 10000
                });
                return;
            }

            if (['processed', 'unknown', 'failed'].indexOf(res.transaction) !== -1) {
                $scope.preLoader = false;
                if($rootScope.servicePage){
                    return $state.go('pages.serviceReceipt', {
                        payment_id: paymentId
                    });
                } else {
                    return $state.go('pages.receipt', {
                        payment_id: paymentId
                    });
                }
            }

            if (res.transaction === 'processing') {
                return $timeout(function() {
                    $scope.checkTrnStatus(paymentId);
                }, 2000);
            }
        }).catch(function () {
            $scope.preLoader = false;

            Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
        });
    };

    $scope.toService = function() {
        var data = {
            serviceId: $stateParams.serviceId,
            fields: [],
            amount: 0,
            autoCheck: false,
            url: $stateParams.furl || $stateParams.serviceId
        };

        $scope.preLoader = true;
        $state.go('pages.payment', data);
    };
}

module.exports = LookupCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/lookup/controllers/lookup.js
 ** module id = 268
 ** module chunks = 1
 **/